// src/App.js
import "./styles/App.css";
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from './Theme/ThemeContext';
import { publicRoutes, authRoutes, protectedRoutes, NotFound } from "./routes/routeconfig";
import Private from "./routes/ProtectedRoute";
import Public from "./routes/PublicRoute";
import PublicLayout from "./Layout/PublicLayout";
import ProtectedLayout from "./Layout/ProtectedLayout";

const App = () => {
    return (
        <ThemeProvider> 
            <Suspense fallback={
                <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center">
                        <div className="w-16 h-16 border-4 border-t-transparent rounded-full animate-spin mb-4"
                             style={{ borderColor: '#6AA48A' }}></div>
                        <p style={{ color: '#22332D' }}>Loading...</p>
                    </div>
                </div>
            }>
                <Routes>
                    {/* Public Routes (home, about, contact) */}
                    {publicRoutes.map(({ path, element: Element }, index) => (
                        <Route
                            key={`public-${path}-${index}`}
                            path={path}
                            element={
                                <Public 
                                    Component={() => (
                                        <PublicLayout>
                                            <Element />
                                        </PublicLayout>
                                    )}
                                    isPublicPage={true}
                                />
                            }
                        />
                    ))}

                    {/* Auth Routes (login/register) */}
                    {authRoutes.map(({ path, element: Element }, index) => (
                        <Route
                            key={`auth-${path}-${index}`}
                            path={path}
                            element={
                                <Public 
                                    Component={() => (
                                        <PublicLayout>
                                            <Element />
                                        </PublicLayout>
                                    )}
                                    isLoginPage={true}
                                />
                            }
                        />
                    ))}

                    {/* Protected Routes */}
                    {protectedRoutes.map(({ path, element: Element }, index) => (
                        <Route
                            key={`protected-${path}-${index}`}
                            path={path}
                            element={
                                <Private 
                                    Component={() => (
                                        <ProtectedLayout>
                                            <Element />
                                        </ProtectedLayout>
                                    )}
                                />
                            }
                        />
                    ))}
                    
                    {/* 404 Route */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </ThemeProvider>
    );
};

export default App;